import React, { Component, PropsWithChildren } from "react";
import { Footer, AfterAuthHeader } from "../../components/commons";
import SideNav from "../../components/SideNav/SideNav";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { GetMaintenanceTypes } from "../../redux/maintenance/maintenanceTypes";
import { ScheduledBanner } from "../../screens";
import MobileMenu from "../../components/MobileMenu/MobileMenu";
import "./Layout.scss";
type AppProps = {
  name?: string;
  isMaintenance?: number;
  maintenanceData?: GetMaintenanceTypes;
  toggle: boolean;
  setToggle: any;
  handleToggle: () => void;
};

interface LayoutState {
  screenWidth: number;
}

class Layout extends Component<PropsWithChildren<AppProps>,LayoutState> {
  constructor(props:any) {
    super(props);
    this.state = {
      screenWidth: window.innerWidth,
    };

     this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    // Add event listener for window resize
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    // Clean up the event listener when the component unmounts
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    // Update screenWidth when the window is resized
    this.setState((prev)=>({
      ...prev,
      screenWidth: window.innerWidth,
  }));
  };

  render() {
    const { isMaintenance, maintenanceData  } = this.props;
    const {screenWidth} = this.state;


    return (
      <>
        <>
          {isMaintenance === 1 && (
            <ScheduledBanner maintenanceData={maintenanceData} />
          )}
        </>
        <div className="d-flex">
          <div className="show-mobile-menu">
          <MobileMenu 
           name={this.props.name}
           toggle={this.props.toggle}
           handleToggle={this.props.handleToggle}
          />
          </div>
          <div
            style={{ width: this.props.toggle ? "16%" : "5%" }}
            className={`${
              this.props.toggle ? "easy-out" : "easy-in"
            } hide-side-menu`}
          >
            <SideNav
              name={this.props.name}
              toggle={this.props.toggle}
              handleToggle={this.props.handleToggle}
            />
          </div>
          <div
            style={{
              width: this.props.toggle ? "84%" : (screenWidth<=430 ? "100vw" : "95vw"),
              minHeight: "95vh",
            }}
            // className='component-container'
            className={`${
              this.props.toggle ? "easy-out" : "easy-in"
            }  component-container`}
          >
            <div
              className="border-bottom"
              style={{ margin: screenWidth<=430 ? "-40px -40px 0 -40px" :"-40px -40px 33px -40px" }}
            >
              <AfterAuthHeader
                toggle={this.state}
                handleToggle={this.props.handleToggle}
              />
            </div>

            <div className="app-body">
              <div className="inside-app-body">{this.props.children}</div>
            </div>
          </div>
        </div>
        <div style={{ padding: 0 }}>
          <Footer />
        </div>
        {/* <div className='main-page'>
        <div className="container-fluid border-bottom item1">
          <AfterAuthHeader toggle={this.state} handleToggle={this.props.handleToggle} />
          </div>
          <div style={{width:this.props.toggle?"18%":"5%"}} className='item2'>
            <SideNav name={this.props.name} toggle={this.props.toggle} handleToggle={this.props.handleToggle} />
          </div>
        <div className="layout-container w-100 item3">
          
          <div className="component-container" style={{width:this.props.toggle?"82%":"95%"}}>
            <div className="content">
              {this.props.children}
            </div>
            {/* <Footer /> */}
        {/* </div>

        </div>
        </div> */}
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  isMaintenance: state.maintenance.isMaintenance,
  maintenanceData: state.maintenance.maintenanceData,
});

export default connect(mapStateToProps)(Layout);
